import dayjs from 'dayjs';
import { date, lazy, mixed, object, string } from 'yup';

import { RegexUtils } from '../regex-utils';

export const companyDetailsValidations = {
  companyHouseRegistrationNumber: string()
    .required('Please enter your company registration number')
    .matches(RegexUtils.companyHouseRegistrationNumberRegex, "Company registration number shouldn't contain special characters")
    .max(100, 'Character length exceeded'),

  companyName: string()
    .required('Please enter company name')
    .matches(RegexUtils.companyName, 'Please enter a valid company name')
    .max(200, 'Character length exceeded'),

  incorporatedOn: date()
    .required('Please provide incorporation date')
    .max(dayjs().toDate(), 'Please provide valid incorporation date')
    .typeError('Please provide a valid incorporation date'),

  companyType: lazy((value) => {
    switch (typeof value) {
      case 'object':
        return object()
          .shape({
            label: string().required('Please select company type'),
            value: string().required('Please select company type'),
          })
          .nullable()
          .required('Please select company type');
      case 'string':
        return string().required('Please select company type');
      default:
        return mixed().notRequired();
    }
  }),

  businessName: string().required('Please enter business name').max(200, 'Character length exceeded'),

  position: string().required(),
};
